// API Configuration
// In development: local backend on port 8081
// In production: deployed backend URL (set via REACT_APP_API_URL)
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8081/api/canton';

// Initial empty state
export const INITIAL_STATE = {
  networkStats: {
    totalRewardsCollected: null,
    currentRound: null,
    validatorCount: 0,
    svCount: 0,
    ccPrice: null,
    amuletPriceVotes: [],
    totalSupply: null,
  },
  latestRound: {
    round: 0,
    effectiveAt: null,
  },
  openMiningRound: null,
  validators: [],
  svNodes: [],
  transactions: [],
  dsoInfo: null,
};
